"use client";

import Link from "next/link";
import { IndustryButtonLink } from "@/components/screen/global-components/industry";
import Icon from "@/components/ui/Icon";
import { Typography } from "@/components/ui/typography";
import { ServicesIndustryProps } from "./types";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { INDUSTRIES } from "./constants";

const ServicesIndustry = ({ className }: ServicesIndustryProps) => {
  return (
    <section className={cn("section bg-[#f7f7f9]", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="grid grid-cols-1 gap-6 md:flex md:items-start md:gap-[min(3rem,3.33vw)]">
          <div className="grid grid-cols-1 gap-2 md:gap-8 w-full md:min-w-[280] md:max-w-[50%] lg:max-w-[436]">
            <Typography
              variant="heading4"
              className="lg:leading-[136%] text-center md:text-left"
            >
              <h2>Scale globally with industry specialized translators</h2>
            </Typography>
            <Typography
              variant="subHeadingSm"
              className="text-gray-600 text-center md:text-left"
              asChild
            >
              <p>
                Linguists with industry subject matter expertise ensure
                accurate, high-quality translations that are convenient, fast,
                reliable, and secure at any volume.
              </p>
            </Typography>
          </div>
          <div className="grid grid-cols-1 gap-4 flex-auto min-w-0">
            <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
              {INDUSTRIES.map(({ icon, href, title }, idx) => {
                return (
                  <IndustryButtonLink
                    href={href}
                    imageUrl={icon}
                    imageAlt={title}
                    key={idx}
                  >
                    {title}
                  </IndustryButtonLink>
                );
              })}
              <Link
                href="/industries"
                className="flex not-even:col-span-2 md:hidden h-[84]"
              >
                <span className="flex-auto min-w-0 flex group rounded-2xl border-1 bg-white items-center justify-between py-5 px-6 md:py-3 cursor-pointer text-gray-500 text-lg leading-[130%] md:py-4 md:text-xl md:leading-[150%] border-[#BAD5F9] hover:text-[#4381E5] hover:border-[#4381E5]">
                  <span>Explore industries</span>
                  <Icon
                    id="icon-arrow-right_24"
                    width={24}
                    height={24}
                    className="shrink-0 w-6 h-6 ml-2"
                  />
                </span>
              </Link>
            </div>
            <Link
              href="/industries"
              className="cursor-pointer hidden md:inline-flex text-blue-500 text-sm leading-[150%] font-semibold"
            >
              <span className="inline-flex items-center gap-2">
                <span>Explore industries</span>
                <Icon
                  id="icon-arrow-right_24"
                  width={24}
                  height={24}
                  className="shrink-0 w-6 h-6 ml-2"
                />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(ServicesIndustry);
